// src/components/buyerPersona/QuestionModule.jsx
import React from 'react';
import QuestionCard from './QuestionCard';

const QuestionModule = ({ module, title, questions, responses, onAnswer, moduleNumber, totalModules }) => {
    if (!questions || questions.length === 0) {
        return (
            <div className="bg-white rounded-lg p-4 text-center">
                <p className="text-gray-600">No hay preguntas disponibles para este módulo.</p>
            </div>
        );
    }

    return (
        <div className="question-module">
            {/* Module Header - Minimal */}
            <div className="mb-4">
                <h2 className="text-lg font-medium text-gray-900">
                    {title}
                </h2>
                <p className="text-sm text-gray-500">
                    {questions.length} pregunta{questions.length !== 1 ? 's' : ''}
                </p>
            </div>

            {/* Questions */}
            <div className="space-y-4">
                {questions.map((question, index) => (
                    <QuestionCard
                        key={question.id}
                        question={question}
                        questionNumber={index + 1}
                        selectedAnswer={responses[question.question]}
                        onAnswer={onAnswer}
                    />
                ))}
            </div>
        </div>
    );
};

export default QuestionModule; 